/** Shown when the embed URL omits ?companyId= */
export const MISSING_WIDGET_COMPANY_ID_MESSAGE =
  'Invalid Widget Installation: Missing Company ID.';

/**
 * Resolve tenant company id from the embed URL (?companyId=).
 * @param {string} [searchString] — defaults to window.location.search
 * @returns {string}
 */
export function resolveWidgetCompanyIdFromUrl(searchString) {
  const query =
    typeof searchString === 'string'
      ? searchString
      : typeof window !== 'undefined'
        ? window.location.search
        : '';
  const urlParams = new URLSearchParams(query);
  const targetCompanyId = urlParams.get('companyId');
  return typeof targetCompanyId === 'string' ? targetCompanyId.trim() : '';
}

/**
 * Resolve the app/brand id from the embed URL (?appId=). Optional — a session
 * without an appId is treated as a global/company-level conversation.
 * @param {string} [searchString] — defaults to window.location.search
 * @returns {string}
 */
export function resolveWidgetAppIdFromUrl(searchString) {
  const query =
    typeof searchString === 'string'
      ? searchString
      : typeof window !== 'undefined'
        ? window.location.search
        : '';
  const urlParams = new URLSearchParams(query);
  const targetAppId = urlParams.get('appId');
  return typeof targetAppId === 'string' ? targetAppId.trim() : '';
}

/**
 * Copy-paste iframe snippet for external sites.
 * @param {string} embedOrigin — e.g. https://shiftypm-staging.web.app
 * @param {string} companyId
 * @param {string} [appId] — optional app/brand id to scope sessions per app.
 * @returns {string}
 */
export function buildChatWidgetEmbedSnippet(embedOrigin, companyId, appId = '') {
  const origin = String(embedOrigin || '').trim().replace(/\/$/, '');
  const id = encodeURIComponent(String(companyId || '').trim());
  const app = encodeURIComponent(String(appId || '').trim());
  const src = app
    ? `${origin}/embed/chat?companyId=${id}&appId=${app}`
    : `${origin}/embed/chat?companyId=${id}`;
  return `<iframe src="${src}" width="350" height="500" style="border:none; position:fixed; bottom:20px; right:20px; z-index:9999;"></iframe>`;
}

/**
 * Best-effort parent page URL for iframe embeds (Originating Node).
 * @returns {string}
 */
export function resolveOriginatingPageUrl() {
  if (typeof window === 'undefined') return '';
  try {
    if (window.parent && window.parent !== window) {
      return document.referrer || '';
    }
    return window.location.href || '';
  } catch {
    return document.referrer || window.location.href || '';
  }
}

/**
 * Visitor IANA timezone from the browser.
 * @returns {string}
 */
export function resolveVisitorTimezone() {
  if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) return '';
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}
